module.exports = __webpack_public_path__ + "d70e230a48875885ad88f8325d6fc25b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/youth-student.png
// module id = 483
// module chunks = 0